module.exports = __webpack_public_path__ + "static/media/img-hero-frame.2c74aaab.jpg";